export default {
	banner: {
		tittle: '構建你的人工智能宇宙',
		sub_tittle: '定義下一個萬億美元的人工智能經濟'
	},
	validator: {
		tittle: '公開招募驗證者',
		sub_tittle: '剩餘席位',
		remain_text: '剩餘席位',
		price_text: '價格',
		wallet_text: 'Base鏈錢包地址',
		description_text: '請轉賬至上述地址'
	},
	about: {
		section_tittle: "關於我們",
		tittle1: "定義下一代人工智能經濟",
		tittle1_info_text: "AIVerse 率先推出去中心化的 AI 代理價值網絡，整合 AI 創造、交易和自主經濟，實現 AI 驅動生產資產所有權的民主化。",
		tittle2: "為什麼選擇我們？",
		sub_tittle1: "開放生態系統",
		info_text1: "利用無代碼人工智能工具和代幣化收益分享打破技術寡頭壟斷",
		sub_tittle2: "基礎設施稀缺",
		info_text2: "50+ 全球 Prime 驗證者共享生態系統獎勵",
		sub_tittle3: "尖端科技",
		info_text3: "專有 AI 引擎 3.0 推理速度提升 200%，達到 1M+ TPS",
		tittle3: "可信度",
		tittle3_info_text: "由前Google DeepMind 架構師和前微軟 Azure 首席工程師領導，由 SlowMist 審計智能合約，並由幣安實驗室和頂級創投公司支援。",
		user1_desc1: "前Google DeepMind高級研究員",
		user1_desc2: "參與Transformer架構設計",
		user1_desc3: "發表20+頂級AI論文",
		user2_desc1: "前Microsoft Azure AI首席架构师",
		user2_desc2: "主導千萬級用户AI產品",
		user2_desc3: "12年企業級AI經驗",
		circle1_text:'App Store屬性',
		circle2_text:'NYSE屬性'
	},
	architecture: {
		section_tittle: "產品架構",
		tittle: 'AIverse四類資產體系',
		sub_tittle1: 'Prime 驗證者',
		sub_tittle1_text1: "首席驗證者",
		sub_tittle1_text2: "生態基礎設施節點",
		sub_tittle1_text3: "享有治理權+收益分配",
		sub_tittle2: 'AI代理代幣',
		sub_tittle2_text1: "應用幣",
		sub_tittle2_text2: "AI項目獨立代幣",
		sub_tittle2_text3: "與AION價值聯動",
		sub_tittle3: 'AION',
		sub_tittle3_text1: "平台幣",
		sub_tittle3_text2: "核心價值載體",
		sub_tittle3_text3: "支付、質押、治理",
		sub_tittle4: 'AIP',
		sub_tittle4_text1: "AIverse Points積分",
		sub_tittle4_text2: "貢獻度量化工具",
		sub_tittle4_text3: "決定參與權益等級",
	},
	roadmap: {
		section_tittle: '路線圖',
		parse_4_tittle:"階段4",
		parse_4_text1:"1000+AI Agent生態",
		parse_4_text2:"全球Top 3 AI平台",
		parse_4_text3:"10億用户生態",
		parse_4_text4:"市值目標",
		parse_4_text5:"100億美元",
		parse_2_tittle:"階段2",
		parse_2_text1:"AION上線Top 5 CEX",
		parse_2_text2:"100個AI Agent上線",
		parse_2_text3:"20萬月活用户",
		parse_2_text4:"市值目標",
		parse_2_text5:"15億美元",
		parse_3_tittle:"階段3",
		parse_3_text1:"多鏈部署完成",
		parse_3_text2:"500個AI Agent上線",
		parse_3_text3:"100萬月活用户",
		parse_3_text4:"市值目標",
		parse_3_text5:"30億美元",
		parse_1_tittle:"階段1",
		parse_1_text1:"完成500萬種子輪",
		parse_1_text2:"Prime Validator預售",
		parse_1_text3:"5萬種子用户",
		parse_1_text4:"市值目標",
		parse_1_text5:"5億美元",
	},
	footer:{
		sub_tittle:"建構你的人工智慧宇宙",
		main_tittle:"與我們一起 定義AI經濟的未來"
	},
	contact:{
		tittle:"聯絡我們"
	},
	common: {
		copySuccess:"復製成功!"
	}
}